import {Component} from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams, Platform} from 'ionic-angular';
import {Storage} from "@ionic/storage";
import {ServiceProvider} from "../../providers/service/service";


@Component({
    selector: 'page-student-active',
    templateUrl: 'student-active.html',
})
export class StudentActivePage {

    School = 'GEIS';
    FUserId: any;
    SchoolData = {};
    datanotfound: any;
    StudentData = [];
    StudentData1 = [];
    DataSearch:any;

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public loadingCtrl: LoadingController,
                public platform: Platform,
                public service: ServiceProvider,
                public storage: Storage) {
        this.platform.ready().then(() => {
            Promise.all([this.storage.get('LoginData'), this.storage.get('AllotedMobileNumber')]).then(values => {
                this.FUserId = values[0]['FUserId'];

                this.SchoolData = {
                    "GWW": 2,
                    "GWE": 3,
                    "GEIS": 1
                };
                this.loadData(this.SchoolData[this.School]);
            })
        })
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad StudentActivePage');
    }

    active_tab(tab) {
        console.log(tab);
        this.School = tab;
        this.loadData(this.SchoolData[this.School]);
    }

    doRefresh(refresher) {
        console.log('Begin async operation', refresher);

        this.loadData(this.SchoolData[this.School]);
        setTimeout(() => {
            console.log('Async operation has ended');

            refresher.complete();
        }, 2000);
    }

    loadData(SchoolId) {
        let loading = this.loadingCtrl.create({
            content: 'Loading'
        });
        loading.present();

        this.StudentData = [];
        let url = "app_web_service/get_student_login?FSchoolId=" + SchoolId + "&FUserId=" + this.FUserId;
        this.service.httpcall(url).subscribe(data => {
            loading.dismiss();
            console.log(data);
            if (data['response'] == "success") {
                this.StudentData1 = data['data'];
                this.StudentData = this.StudentData1;
            } else {
                this.service.showAlert(data['response'], data['error_description']);
            }

        }, error => {

            loading.dismiss();
            this.service.showAlert("Timeout!", "Try again!");
        })
    }

    active_student(item){
        let loading = this.loadingCtrl.create({
            content: 'Loading'
        });
        loading.present();

        let url = "app_web_service/active_student_by_school?FStudentLoginId="+item.Id+"&FSchoolId=" + this.SchoolData[this.School] + "&FUserId=" + this.FUserId;
        this.service.httpcall(url).subscribe(data => {
            loading.dismiss();
            console.log(data);
            if (data['response'] == "success") {
                this.service.showAlert(data['response'], data['message']);
                this.loadData(this.SchoolData[this.School]);
            } else {
                this.service.showAlert(data['response'], data['error_description']);
            }

        }, error => {

            loading.dismiss();
            this.service.showAlert("Timeout!", "Try again!");
        })
    }

    searchData(ev: any) {

        // Reset items back to all of the items
        this.StudentData = this.StudentData1;
        // set val to the value of the searchbar
        let val = ev.target.value;
        // if the value is an empty string don't filter the items
        if (val && val.trim() != '') {
            this.StudentData = this.StudentData.filter((item) => {
                return (item.FirstName.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
                    (item.MiddleName.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
                    (item.LastName.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
                    (item.EnrolmentId.toLowerCase().indexOf(val.toLowerCase()) > -1);
            })
        }

    }

}



// WEBPACK FOOTER //
// ./src/pages/student-active/student-active.ts